import React from "react";

interface ICounterProps {
  time: number;
  setTime: React.Dispatch<React.SetStateAction<number>>;
}

export const Counter: React.FC<ICounterProps> = ({ time, setTime }) => {
  React.useEffect(() => {
    const interval = setInterval(() => {
      setTime((time) => time - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [setTime]);

  return <>Отправить повторно через {time} секунд</>;
};
